__turbopack_context__.v({
  "btn": "filtersBtn-module-scss-module__eMZa1a__btn",
  "childrenWrp": "filtersBtn-module-scss-module__eMZa1a__childrenWrp",
  "counter": "filtersBtn-module-scss-module__eMZa1a__counter",
  "desktopIconOnly": "filtersBtn-module-scss-module__eMZa1a__desktopIconOnly",
});
